<input
  type="number"

  [formControl]="control"

  class="kt-input kt-input-sm text-right"
/>

<mat-error
  *ngIf="
    control?.invalid &&
    control?.touched
  ">

  {{ getError() }}

</mat-error>